import React, { useState } from 'react';
import { Button, Container, FormControl, FormLabel, Input, Stack, Typography } from '@mui/joy';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';

const ConfirmSignup = () => {
    const { confirmSignUp } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const prefillEmail = (location.state as { email?: string } | null)?.email ?? '';

    const [email, setEmail] = useState(prefillEmail);
    const [code, setCode] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await confirmSignUp(email, code);
            navigate('/login');
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Confirmation failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 4 }}>
            <Typography level="h2" mb={2}>
                Confirm Email
            </Typography>
            <Typography level="body-sm" mb={2}>
                Check your email for a 6-digit confirmation code.
            </Typography>
            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <FormControl>
                        <FormLabel>Email</FormLabel>
                        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Confirmation Code</FormLabel>
                        <Input
                            type="text"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            placeholder="123456"
                            required
                        />
                    </FormControl>
                    {error && (
                        <Typography color="danger" level="body-sm">
                            {error}
                        </Typography>
                    )}
                    <Button type="submit" loading={loading}>
                        Confirm
                    </Button>
                </Stack>
            </form>
        </Container>
    );
};

export default ConfirmSignup;
